import { formatMetersToString } from "../../utils/stringUtils";
import Measure from "./measure";
import LineString from "ol/geom/LineString";
// class that hold line coordinates and calculate length
class LineDistance2D extends Measure {
  static Type = "distance";
  constructor(lineCoordinates, name) {
    super(name, "distance");
    this.line = new LineString(lineCoordinates);
  }

  getGeometry() {
    return this.line;
  }

  get coordinates() {
    return this.line.getCoordinates();
  }

  set coordinates(lineCoordinates) {
    this.line.setCoordinates(lineCoordinates);
  }

  getLength() {
    return this.line.getLength();
  }

  getResult() {
    return formatMetersToString({ length: this.getLength(), units: "m" });
  }

  static fromSerialized(serialized) {
    let measure = new LineDistance2D(serialized.points || [], serialized.name);
    measure.id = serialized.id;
    measure.toBeStored = serialized.toBeStored;
    measure.dbId = serialized.dbId;
    return measure;
  }
}

export default LineDistance2D;
